
<template>
  <div class="content-wrapper">
    <section class="content-header">
      <div class="container-fluid">
        <div class="row mb-2">
          <div class="col-sm-6">
            <h1>cms menu setting</h1>
          </div>
          <div class="col-sm-6">
            <ol class="breadcrumb float-sm-right">
              <li class="breadcrumb-item">
                <router-link :to="{name: 'Home'}">Home</router-link>
              </li>
              <li class="breadcrumb-item active">cms menu setting</li>
            </ol>
          </div>
        </div>
      </div>
    </section>

    <section class="content">
        <div class="container-fluid">
          <div class="card" id="CmsMenuSetting">
            <div class="overlay" v-if="is_loading">
              <i class="fas fa-2x fa-sync-alt fa-spin"></i>
            </div>
            <form @submit.prevent="handleSubmission()" method="POST" novalidate>
              <div class="card-header">
                <h3 class="card-title" v-if="!is_edit">Create</h3>
                <h3 class="card-title" v-if="is_edit">Edit</h3>
                <div class="card-tools">
                  <router-link class="btn btn-info" :to="{name: 'CmsMenuSettingList'}"><i class="fas fa-list"></i> List
                  </router-link>
                </div>
              </div>
              <div class="card-body">
                <div class="row">
                    <div class="col-8">
                    
                    
            <div class="form-group required" >
              <label class="control-label">Menu group</label>
              <input type="text" id="menu_group_id" name="menu_group_id"
                     v-bind:class="{'has-error' : errors.has('menu_group_id')}"
                     v-validate="'required'"
                     v-model="value.menu_group_id" class="form-control menu_group_id"
                     placeholder="Menu group">
              <div class="help text-danger" v-show="errors.has('menu_group_id')">
                {{ errors.first("menu_group_id") }}
              </div>
            </div>
            <div class="form-group required" >
              <label class="control-label">Parent</label>
              <input type="text" id="parent_id" name="parent_id"
                     v-bind:class="{'has-error' : errors.has('parent_id')}"
                     v-validate="'required'"
                     v-model="value.parent_id" class="form-control parent_id"
                     placeholder="Parent">
              <div class="help text-danger" v-show="errors.has('parent_id')">
                {{ errors.first("parent_id") }}
              </div>
            </div>
            <div class="form-group required" >
              <label class="control-label">Order</label>
              <input type="text" id="order" name="order"
                     v-bind:class="{'has-error' : errors.has('order')}"
                     v-validate="'required'"
                     v-model="value.order" class="form-control order"
                     placeholder="Order">
              <div class="help text-danger" v-show="errors.has('order')">
                {{ errors.first("order") }}
              </div>
            </div>
            <div class="form-group required" >
              <label class="control-label">Title</label>
              <input type="text" id="title" name="title"
                     v-bind:class="{'has-error' : errors.has('title')}"
                     v-validate="'required'"
                     v-model="value.title" class="form-control title"
                     placeholder="Title">
              <div class="help text-danger" v-show="errors.has('title')">
                {{ errors.first("title") }}
              </div>
            </div>
            <div class="form-group " >
              <label class="control-label">Icon</label>
              <input type="text" id="icon" name="icon"
                     
                     
                     v-model="value.icon" class="form-control icon"
                     placeholder="Icon">
              
            </div>
            <div class="form-group required" >
              <label class="control-label">Slug Url</label>
              <input type="text" id="slug_url" name="slug_url"
                     v-bind:class="{'has-error' : errors.has('slug_url')}"
                     v-validate="'required'"
                     v-model="value.slug_url" class="form-control slug_url"
                     placeholder="Slug Url">
              <div class="help text-danger" v-show="errors.has('slug_url')">
                {{ errors.first("slug_url") }}
              </div>
            </div>
            <div class="form-group " >
              <label class="control-label">Css Class</label>
              <input type="text" id="css_class" name="css_class"
                     
                     
                     v-model="value.css_class" class="form-control css_class"
                     placeholder="Css Class">
              
            </div>
                    </div>
                </div>
              </div>
              <div class="card-footer">
                <button type="submit" v-if="!is_edit" class="btn btn-primary">Submit</button>
                <button type="submit" v-if="is_edit" class="btn btn-primary">Update</button>
              </div>
            </form>
          </div>
        </div>
    </section>
  </div>
</template>

<script>

//import MasterLayout from "@/components/layouts/MasterLayoutComponent";
import {DepartmentsAPI, CommonAPI} from "@/services/api";
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import axios from "axios";

export default {
  name: "CmsMenuSettingForm",
  metaInfo: {
    title: "cms menu setting | Dotlines"
  },
  components: {
    DatePicker
  },
  data: () => ({
    isSelectorLoading: false,
    is_loading: false,
    is_edit: false,
    params: {},
    
    value: {
        
        
    },
    pre: {
      
    }
  }),
  methods: {
    
    
    
    handleSubmission() {
      let _this = this;
      this.$validator.validateAll().then((result) => {
        if (result) {
          _this.is_loading = true;
          let api_url = "/cms_menu_settings";
          let method = "POST";
          if (_this.is_edit) {
            api_url = "/cms_menu_settings/" + _this.$route.params.id
            method = "PUT";
          }

          

          axios({
            method: method, url: api_url,
            data: _this.value,
            headers: {"Content-Type": "application/json"},
          }).then(function (response) {
            _this.$toaster.success(response.data.message);
            _this.$router.push({"name": "CmsMenuSettingList"});
          }).catch((errors) => {
            if (errors.response.status === 500) {
              _this.$toaster.error(errors.response.data.message);
            }
            _this.$setErrorsFromResponse(errors.response.data);
          }).finally(() => {
            _this.is_loading = false;
          });
        }
      });
    },
    getDetail: function (id) {
      return new Promise((resolve, reject) => {
        let api_url = "/cms_menu_settings/" + id;
        axios.get(api_url)
          .then(response => {
            resolve(response);
          })
          .catch((error) => {
            //console.log("error " + error);
            reject(error);
          });
      });
    },
    async initialize() {
      this.is_loading = true;
      this.params = this.$route.params;
      
      if (!_.isEmpty(this.params) && this.params.id !== undefined) {
        this.is_edit = true;
      }
      if (this.is_edit) {
        await this.getDetail(this.params.id).then(response => {
          this.value = response.data;
        }).catch((error) => {
          console.log(error.response);
        });
        
        
      }
      
      this.is_loading = false;
    }
  },
  mounted() {
    this.initialize()
  },
  /*created() {
    this.$emit("update:layout", MasterLayout);
  },*/
}
</script>

        